import React from 'react';
import { Autocomplete, TextField } from '@mui/material';

export const CommonSelect = ({
  customStyles = { minWidth: 100, maxWidth: 'auto' },
  disabled,
  handleChange,
  name,
  options,
  placeholder,
  size = 'small',
  value = '',
  handleInputChage = () => {},
  required = false,
  multiple = false,
  ...restProps
}) => {
  const defaultAutocompleteStyles = {
    "& .MuiAutocomplete-listbox": {
      padding: "8px",
      "& .MuiAutocomplete-option": {
        borderRadius: "8px",
        margin: "4px 0",
        padding: "10px 14px",
        transition: "all 0.2s ease",
        "&:hover": {
          backgroundColor: "rgba(22, 114, 222, 0.1) !important",
        },
        "&[aria-selected='true']": {
          backgroundColor: "rgba(22, 114, 222, 0.15) !important",
          fontWeight: "600",
          "&.Mui-focused": {
            backgroundColor: "rgba(22, 114, 222, 0.2) !important",
          },
        },
        "&.Mui-focused": {
          backgroundColor: "rgba(22, 114, 222, 0.1) !important",
        },
      },
    },
    "& .MuiPaper-root": {
      borderRadius: "12px",
      boxShadow: "0 8px 24px rgba(22, 114, 222, 0.15)",
      border: "1px solid rgba(22, 114, 222, 0.1)",
      marginTop: "8px",
      "& .MuiAutocomplete-listbox": {
        "& .MuiAutocomplete-option": {
          "&:hover": {
            backgroundColor: "rgba(22, 114, 222, 0.1) !important",
          },
          "&[aria-selected='true']": {
            backgroundColor: "rgba(22, 114, 222, 0.15) !important",
            "&.Mui-focused": {
              backgroundColor: "rgba(22, 114, 222, 0.2) !important",
            },
          },
          "&.Mui-focused": {
            backgroundColor: "rgba(22, 114, 222, 0.1) !important",
          },
        },
      },
    },
    "& .MuiOutlinedInput-root": {
      paddingLeft: "14px !important",
      paddingRight: "14px !important",
      boxSizing: "border-box",
      "& fieldset": {
        borderColor: "rgba(0, 0, 0, 0.23) !important",
        borderWidth: "1px !important",
      },
      "&:hover fieldset": {
        borderColor: "rgba(0, 0, 0, 0.87) !important",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#1672DE !important",
        borderWidth: "2px !important",
      },
      "& .MuiInputBase-input": {
        padding: "8.5px 14px !important",
        boxSizing: "border-box",
      },
    },
  };

  const mergedStyles = {
    ...defaultAutocompleteStyles,
    ...customStyles,
  };

  return (
    <Autocomplete
      multiple={multiple}
      autoHighlight
      disabled={disabled}
      name={name}
      onChange={(event, value, reason) => handleChange(event, value, reason)}
      options={[...options]}
      sx={mergedStyles}
      size={size}
      value={value}
      {...restProps}
      renderInput={(params) => (
        <TextField
          placeholder={placeholder}
          {...params}
          inputProps={{
            ...params.inputProps,
            required: required && !value,
          }}
          error={required && !value}
          helperText={required && !value ? 'This field is required' : ''}
          onChange={(e) => {
            handleInputChage(e.target.value);
            console.log("input value", e.target.value);
            // setDataProp(e.target.value);
            // if (typeof props?.func === "function")
            //   props.func(e.target.value);
          }}
        />
      )}
    />
  );
};
